<template>
  <section id="message">
    <div class="md" v-html="mdfile"></div> 
  </section>
</template>

<script>
import mdfile from "@/docs/states/message.md";
export default {
  name: "message",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.states.message.name);
    this.$emit("update-tagline", this.$root.yamlData.states.message.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
